import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

export const notifApi = {
  list: (params) => api.get('/notifications', { params }).then(unwrap),
  unreadCount: (byCategory = false) =>
    api.get('/notifications/unread-count', { params: { by_category: byCategory ? 'true' : 'false' } }).then(unwrap),
  markRead: (id) => api.post(`/notifications/${id}/read`).then(unwrap),
  markAllRead: () => api.post('/notifications/read-all').then(unwrap),
  bulkRead: (ids) => api.post('/notifications/bulk-read', { ids }).then(unwrap),
  remove: (id) => api.delete(`/notifications/${id}`).then(unwrap),
  removeBulk: (ids) => api.delete('/notifications/bulk', { data: { ids } }).then(unwrap),
  clearRead: () => api.delete('/notifications/clear-read').then(unwrap),
  preferences: () => api.get('/notifications/preferences').then(unwrap),
  updatePreferences: (payload) => api.put('/notifications/preferences', payload).then(unwrap),
  setEventPreference: (eventType, patch) =>
    api.put(`/notifications/preferences/event/${encodeURIComponent(eventType)}`, patch).then(unwrap),
  setEventPreferencesBulk: (events) =>
    api.put('/notifications/preferences/events/bulk', { events }).then(unwrap),
};
